export enum BorrowerType {
  Person = 'person',
  Company = 'company',
}
